import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './IntercomHelp.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { useMemo } from 'react'
import { Button } from 'blaze-ui/Button'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const INTERCOM_INTEGRATION_HELP_MESSAGE =
  "Hello! Can you help me connect my accounts in Autopilot Onboarding? I'm on the account connection step right now."

export const IntercomHelp = ({ size = 'md' }: { size?: 'sm' | 'md' }) => {
  const workspace = useCurrentWorkspace()
  const randomNumber = useMemo(() => Math.floor(Math.random() * 10) + 5, [])
  const { isIOSNative } = useResponsiveDesign()

  const isIntercomAvailable = typeof window !== 'undefined' && typeof window.Intercom === 'function'

  if (!isIntercomAvailable) return null
  if (workspace?.is_ap_freemium || isIOSNative) return null

  if (size === 'sm') {
    return (
      <div className={Styles.smallRoot}>
        <div className={Styles.icon}>🛟</div>
        <Heading level={4}>Need help connecting your accounts? </Heading>
        <Button
          variant="secondary"
          onPress={() => {
            window.Intercom('showNewMessage', INTERCOM_INTEGRATION_HELP_MESSAGE)
          }}
          size="lg"
        >
          Get live help now
        </Button>
      </div>
    )
  }

  return (
    <div className={Styles.root}>
      <div className={Styles.icon}>🛟</div>
      <div className={Styles.content}>
        <Heading level={3}>Need help connecting your accounts? </Heading>
        <Text color="var(--dark-80)">
          Get support from a dedicated onboarding specialist. We've got your back. <br />
          You're not alone: <span className={Styles.bold}>{randomNumber}</span> people are onboarding live right now.
          We're happy to help!
        </Text>
        <div className={Styles.button}>
          <Button
            variant="secondary"
            onPress={() => {
              window.Intercom('showNewMessage', INTERCOM_INTEGRATION_HELP_MESSAGE)
            }}
          >
            Get live help now
          </Button>
        </div>
      </div>
    </div>
  )
}
